import React from 'react';
import { Line } from 'react-chartjs-2';

export class HenriChart extends React.Component {
  constructor() {
    super();
    this.state = {
      height: 300,
      width: 500
    };
  }
  render() {
    //console.log("This player is" + JSON.stringify(this.props.selectedPlayer));
    var legend = { labels: { boxWidth: 20 } };
    /*      display: false,
            labels: {
                fontColor: 'rgb(255, 99, 132)',
                boxWidth: 20
            }
        };*/
    var lineChartData = {
      labels: this.props.seasons,
      datasets: [
        {
          label: 'Cap Hit',
          backgroundColor: '#DC143C',
          borderColor: '#DC143C',
          fill: false,
          data: this.props.cap
        },
        {
          label: 'HENRI',
          backgroundColor: '#008000',
          borderColor: '#008000',
          fill: false,
          data: this.props.henri
        },
        {
          label: 'Net Surplus',
          backgroundColor: '#4169E1',
          borderColor: '#4169E1',
          fill: false,
          data: this.props.surplus
        }
      ]
    };
    return (
      <Line
        options={{
          maintainAspectRatio: true,
          responsive: false
        }}
        data={lineChartData}
        legend={legend}
        height={this.props.height}
        width={this.props.width}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/HenriChart.js